import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PDP_SIZE_GUIDE_TYPE } from '@/components/blocks/ProductDetails/SizesGuideModal';

interface Props {
	gender: string;
	family: string;
	onClose: () => void;
}

export const ProductDetailsSizesGuideHeader: React.FC<Props> = ({ gender, family, onClose }) => {
	const title = useMemo(() => {
		if (family === PDP_SIZE_GUIDE_TYPE.CLOTHES) {
			return `ROPA PARA ${gender}`;
		}

		if (family === PDP_SIZE_GUIDE_TYPE.SHOES) {
			return `CALZADO PARA ${gender}`;
		}

		if (family === PDP_SIZE_GUIDE_TYPE.ACCESSORIES) {
			return `ACCESORIOS PARA ${gender}`;
		}

		return 'GUÍA DE TALLAS';
	}, [gender, family]);

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
			}}
		>
			<Typography
				sx={{
					fontSize: { xs: '18px', md: '20px' },
					fontWeight: 800,
				}}
			>
				{title}
			</Typography>
			<CloseIcon
				sx={{
					fontSize: '24px',
					cursor: 'pointer',
					color: '#333',
				}}
				onClick={onClose}
			/>
		</Box>
	);
};
